module.exports = __webpack_public_path__ + "letterFadeUnrollInRight.gif";